module.exports = __webpack_public_path__ + "6fc42993b68532c43036b360ca36ae61.png";